import React from "react";
import ReusablePDFLayout from "../ReusablePDFLayout";
import sign from "../../../assest/images/Singn.png";

export const Page9 = ({
  Earning,
  Deductions,
  Benefits,
  Salarydata,
  RowIDdata,
}) => {
  const headerStyle = {
    backgroundColor: "#d9d9d9",
    fontWeight: "bold",
  };

 
  let EarningData = Earning.filter((val) => /^[A-Za-z]/.test(val?.componentName)) // Filters only alphabetic names
    .sort((a, b) => a?.componentName.localeCompare(b?.componentName)); // Sorts alphabetically

  let Deductiondata = Deductions.filter((val) =>
    /^[A-Za-z]/.test(val?.componentName)
  ) // Filters only alphabetic names
    .sort((a, b) => a?.componentName.localeCompare(b?.componentName)); // Sorts alphabetically

  
  let Benefitsdata = Benefits.filter((val) =>
    /^[A-Za-z]/.test(val?.componentName)
  ) // Filters only alphabetic names
    .sort((a, b) => a?.componentName.localeCompare(b?.componentName)); // Sorts alphabetically

    const capitalizeFirstLetter = (str) => {
      if (!str) return "";
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };
    const candidateName = capitalizeFirstLetter(RowIDdata[0]?.candidateName);
  const totalRowStyle = {
    backgroundColor: "#d9d9d9",
  };
  return (
    <ReusablePDFLayout>
      <div className="parentcls">
        <p className="bol" style={{ textDecoration: "underline" }}>
          Annexure A
        </p>
        <div
          style={{
            display: "flex",
            margin: "15px 40px",
            justifyContent: "space-between",
          }}
        >
          <div style={{ width: "50%" }}>
            <p className="para">
              <span style={{ fontWeight: "800" }}>Name:</span>{" "}
              {candidateName}
            </p>
            <p className="para">
              <span style={{ fontWeight: "800" }}>Designation:</span>{" "}
              {RowIDdata[0]?.position}
            </p>
            <p className="para">
              <span style={{ fontWeight: "800" }}>Department :</span>{" "}
              {RowIDdata[0]?.department}
            </p>
          </div>

          <div style={{ width: "50%", marginLeft: "155px" }}>
            <p className="para">
              <span style={{ fontWeight: "800" }}>Location:</span>{" "}
              {RowIDdata[0]?.location}
            </p>
            <p className="para">
              <span style={{ fontWeight: "800" }}>Employee Code:</span> {" "} {Salarydata?.empCode}
            </p>
            <p className="para">
              <span style={{ fontWeight: "800" }}>Grade:</span>{" "}
              A
            </p>
          </div>
        </div>
        <table
          className="tableStyle"
          border="1"
          cellSpacing="0"
          cellPadding="5"
        >
          <thead>
            <tr style={headerStyle}>
              <td colSpan="3" style={{ textAlign: "left" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    width: "100%",
                  }}
                >
                  <span>CTC ALLOCATION</span>
                  <span style={{marginLeft:'10%'}}>{(Salarydata?.ctc / 12)?.toFixed(2)}</span>
                  <span>{Salarydata?.ctc}</span>
                </div>
              </td>
            </tr>

            <tr style={headerStyle}>
              <td>Salary Components</td>
              <td>Monthly</td>
              <td>Annually</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="3" style={{ textAlign: "center" }} className="para">
                <b>Fixed (A)</b>
              </td>
            </tr>
            <tr>
              <td>{EarningData[0]?.componentName}</td>
              <td>{EarningData[0]?.monthly}</td>
              <td>{EarningData[0]?.yearly}</td>
            </tr>
            <tr>
              <td>{EarningData[1]?.componentName}</td>
              <td>{EarningData[1]?.monthly}</td>
              <td>{EarningData[1]?.yearly}</td>
            </tr>
            <tr style={totalRowStyle}>
              <td>
                <b>Total (A)</b>
              </td>
              <td><b>{EarningData[0]?.monthly + EarningData[1]?.monthly}</b> </td>
              <td><b>{EarningData[0]?.yearly + EarningData[1]?.yearly}</b></td>
            </tr>
            <tr>
              <td colSpan="3" style={{ textAlign: "center" }}>
                <b>Reimbursement Basket (B)</b>
              </td>
            </tr>
            <tr>
              <td>{EarningData[2]?.componentName}</td>
              <td>{EarningData[2]?.monthly}</td>
              <td>{EarningData[2]?.yearly}</td>
            </tr>
            <tr style={totalRowStyle}>
              <td>
                <b>Total (B)</b>
              </td>
              <td>{EarningData[2]?.monthly}</td>
              <td>{EarningData[2]?.yearly}</td>
            </tr>
            <tr>
              <td>
                <b>{EarningData[3]?.componentName} (C)</b>
              </td>
              <td>{EarningData[3]?.monthly}</td>
              <td>{EarningData[3]?.yearly}</td>
            </tr>
            <tr style={totalRowStyle}>
              <td>
                <b>Gross (D) = (A+B+C)</b>
              </td>
              {/* <td>{EarningData[0]?.monthly + EarningData[1]?.monthly + EarningData[2]?.monthly + EarningData[3]?.monthly } </td> */}
              <td><b>{Salarydata?.gross}</b> </td>
              <td><b>{(Salarydata?.gross * 12)?.toFixed(2)}</b> </td>
            </tr>
            <tr>
              <td colSpan="3">
                <b>Deductions</b>
              </td>
            </tr>
            <tr>
              <td>{Deductiondata[1]?.componentName}</td>
              <td>{Deductiondata[1]?.monthly}</td>
              <td>{Deductiondata[1]?.yearly}</td>
            </tr>
            <tr>
              <td>{Deductiondata[0]?.componentName}</td>
              <td>{Deductiondata[0]?.monthly}</td>
              <td>{Deductiondata[0]?.yearly}</td>
            </tr>
            <tr style={totalRowStyle}>
              <td>
                <b>Total Deductions</b>
              </td>
              {/* <td>{Deductiondata[1]?.monthly + Deductiondata[0]?.monthly}</td> */}
              <td><b>{Salarydata?.totalDeductions}</b></td>
              <td><b>{(Deductiondata[1]?.yearly + Deductiondata[0]?.yearly)?.toFixed(2)}</b></td>
            </tr>
            <tr>
              <td colSpan="3" style={{ textAlign: "center" }}>
                <b>Benefits</b>
              </td>
            </tr>
            <tr>
              <td>{Benefitsdata[1]?.componentName}</td>
              <td>{Benefitsdata[1]?.monthly}</td>
              <td>{Benefitsdata[1]?.yearly}</td>
            </tr>
            <tr>
              <td>{Benefitsdata[0]?.componentName}</td>
              <td>{Benefitsdata[0]?.monthly}</td>
              <td>{Benefitsdata[0]?.yearly}</td>
            </tr>
            <tr>
              <td>{Benefitsdata[2]?.componentName}</td>
              <td>{Benefitsdata[2]?.monthly}</td>
              <td>{Benefitsdata[2]?.yearly}</td>
            </tr>
            <tr>
              <td>
                <b>Benefits Total (E)</b>
              </td>
              {/* <td>{Benefitsdata[1]?.monthly + Benefitsdata[0]?.monthly + Benefitsdata[2]?.monthly }</td> */}
              <td><b>{Salarydata?.totalBenefits}</b></td>
              {/* <td>{Benefitsdata[1]?.yearly + Benefitsdata[0]?.yearly + Benefitsdata[2]?.yearly }</td> */}
              <td><b>{Salarydata?.totalBenefits * 12}</b></td>
            </tr>
            <tr>
              <td>
                <b>Monthly & Annual CTC </b>
              </td>
              <td><b>{(Salarydata?.ctc / 12)?.toFixed(2)}</b></td>

              <td><b>{Salarydata?.ctc}</b></td>
            </tr>
            <tr>
              <td>
                <b>Net Take Home </b>
              </td>
              <td><b>{Salarydata?.netPay}</b></td>
              <td><b>{Salarydata?.netPay * 12}</b></td>
            </tr>
          </tbody>
        </table>
        <div
          style={{
            display: "flex",
            width: "80%",
            justifyContent: "space-between",
            marginTop: "0 0 0 15px",
          }}
        >
          <div style={{ marginLeft: "50px", marginTop: "5px" }}>
                  <img src={sign} width={"180px"} />
                  <p className="boldsoff">People Manager</p>
                </div>
          <div style={{ marginTop: "50px", marginLeft: "50px" }}>
            <p className="bolds">I accept the above offer</p>
          </div>
        </div>
      </div>
    </ReusablePDFLayout>
  );
};
